import { render, staticRenderFns } from "./CloseModalButton.vue?vue&type=template&id=30ff3f5c&lang=pug&"
import script from "./CloseModalButton.vue?vue&type=script&lang=ts&"
export * from "./CloseModalButton.vue?vue&type=script&lang=ts&"
import style0 from "./CloseModalButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports